export default "skymp5-front/c7c39cc3bbc1af416c499ad5eddf97f0.png";